import { makeStyles } from 'tss-react/mui'
import { Theme } from '@mui/material/styles'

// Inline canvas shell: a stable min-height so `useCanvasContentResize` can grow
// the Salesforce iframe when the chat route replaces the todos tile.
export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    width: '100%',
    minHeight: 560,
    // Frame the chat drawer inside the Canvas iframe with a brand-pink border
    // (matches Ask Labra AI / todos send-box). CSS also keeps expand hidden if
    // an older @labrav/common build is resolved without hideFullScreenToggle.
    '& .MuiDrawer-paper': {
      border: '2px solid rgb(255,112,138)',
      borderTopLeftRadius: theme.spacing(1),
      borderBottomLeftRadius: theme.spacing(1),
    },
    '& button[title="Expand"], & button[title="Push back in side"]': {
      display: 'none',
    },
  },
}))
